import React, { Component } from "react";
import styled from "styled-components";
import Plan from "components/SubscriptionPicker/Plan";
import {
  PLAN_TYPES,
  PRICES,
  PLAN_TO_TIER_MAPPINGS,
  BILLING_INTERVALS
} from "constants/plans";
import { purchasePlan } from "utils/stripe";

export default class Plans extends Component {
  render() {
    const { actions, planInterval, planLimit, targetPlan, user } = this.props;

    const isHighVolume = planLimit === "high-volume";

    const plans = PLAN_TYPES.filter(plan =>
      targetPlan
        ? plan.id === PLAN_TO_TIER_MAPPINGS[targetPlan.id]
        : plan.visible
    ).map((plan, index) => {
      let calculatedInterval = planInterval;
      if (targetPlan) {
        calculatedInterval =
          targetPlan.interval === "month"
            ? BILLING_INTERVALS.monthly.name
            : BILLING_INTERVALS.yearly.name;
      }

      const isEnterprise = plan.name === "Enterprise";
      const isGrowth = plan.name === "Growth";

      const selfService =
        !!targetPlan || (!isEnterprise && !isGrowth && !isHighVolume);
      const hasPrice = !isEnterprise && !isHighVolume;

      const prices =
        PRICES[calculatedInterval] && PRICES[calculatedInterval][planLimit];
      const price = hasPrice
        ? plan.price || prices[plan.pricePlanId || plan.id]
        : "Let's talk";

      return (
        <Plan
          key={index}
          index={index}
          actions={actions}
          plan={plan}
          planInterval={calculatedInterval}
          planLimit={planLimit}
          price={price}
          purchasePlan={purchasePlan}
          selfService={selfService}
          user={user}
        />
      );
    });

    return <PlansWrapper>{plans}</PlansWrapper>;
  }
}

const PlansWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  margin: 40px 0 16px;
  width: 100%;

  div:first-of-type {
    margin-left: 0;
  }
`;
